import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("admin@medistore.demo");
  const [password, setPassword] = useState("admin123");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await api.post("/auth/login", { email, password });
      onLogin(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || "Unable to sign in");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-shell">
      <div className="login-art">
        <div className="brand-mark large">+</div>
        <p className="eyebrow">MEDISTORE / CONTROL ROOM</p>
        <h1>Inventory that keeps care moving.</h1>
        <p className="login-copy">A focused workspace for hospital stores, vendor supply, department fulfilment, and Vyapar-style vendor ledger.</p>
        <div className="login-note"><span className="pulse-dot" /> <span>Demo environment · Store in-charge access</span></div>
      </div>
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <div className="brand-row">
          <div className="brand-mark">+</div>
          <div><strong>MediStore</strong><span>Hospital inventory</span></div>
        </div>
        <div>
          <p className="eyebrow">WELCOME BACK</p>
          <h2>Sign in to your store</h2>
          <p className="muted">Use the demo account to explore the workspace.</p>
        </div>
        <label>Email
          <input data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
        </label>
        <label>Password
          <input data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} type="password" />
        </label>
        {error && <div className="error" data-testid="login-error">{error}</div>}
        <button className="primary wide" data-testid="login-submit-button" disabled={busy}>
          {busy ? "Signing in…" : "Enter workspace"} <ArrowUpRight size={17} />
        </button>
        <small className="demo-hint">Demo: admin@medistore.demo · admin123</small>
      </form>
    </main>
  );
}
